import { atom } from 'nanostores';

export const editorStore = {
  selectedFile: atom<string | null>(null),
  scrollPosition: atom<{ line: number; ch: number }>({ line: 0, ch: 0 }),
};

export function selectFile(path: string): void {
  editorStore.selectedFile.set(path);
}
